module.exports = __webpack_public_path__ + "./fonts/DMSans-Medium.bbd54a.woff";